<template>
  <div class="custom-text">
    <vs-row class="mb-5">
      <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
        <table>
          <tr>
            <td class="font-medium">{{ $t('no_order') | capitalize }}:</td>
            <td>{{ loadOrder.no_order || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('transporter') | capitalize }}:</td>
            <td>{{ loadOrder.transporter || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('trailer') | capitalize }}:</td>
            <!-- <td>{{ loadOrder.trailer_id || '' }}</td>  -->
            <td>{{ loadOrder.trailer_name || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('plates') | capitalize }}:</td>
            <td>{{ loadOrder.trailer_plates || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">SCAC:</td>
            <td>{{ loadOrder.trailer_scac || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">CAAT:</td>
            <td>{{ loadOrder.trailer_caat || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $tc('type') | capitalize }}:</td>
            <td>{{ loadOrder.trailer_type || '' }}</td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('pallets') | capitalize }}:</td>
            <td>
              {{ signData.pallets }}
            </td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('overtime') | capitalize }}:</td>
            <td>
              {{
                (signData.overtime > 0 ? signData.overtime : $t('no')) | capitalize
              }}
            </td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('signature') | capitalize }}:</td>
            <td v-if="signData.byProxy === 1">
              {{ $t('unsigned') | capitalize }}
            </td>
            <td v-else>
              <a @click.stop="popupActivo = true">{{ $t('open') | capitalize}}</a>
            </td>
          </tr>
        </table>
        <p class="font-medium">{{ $t('comments') | capitalize }}:</p>
        <p>{{ loadOrder.comments || '' }}</p>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
        <banner
          :background="loadOrder.status_color"
          :icon="loadOrder.icon_vue"
          :text="loadOrder.status_name"
        >
          {{ formatDate(loadOrder.updated_at, 'MM/DD/YYYY h:mm:ss') }}
        </banner>
        <table class="mt-4">
          <tr>
            <td class="font-medium">{{ $t('creation_date') | capitalize }}:</td>
            <td>
              {{ formatDate(loadOrder.created_at, 'MM/DD/YYYY h:mm:ss') }}
            </td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('order_date') | capitalize }}:</td>
            <td>
              {{ formatDate(loadOrder.order_date, 'MM/DD/YYYY h:mm:ss') }}
            </td>
          </tr>
          <tr>
            <td class="font-medium">
              {{ $t('confirmation_date') | capitalize }}:
            </td>
            <td>
              {{
                formatDate(loadOrder.confirmation_date, 'MM/DD/YYYY h:mm:ss')
              }}
            </td>
          </tr>
          <tr>
            <td class="font-medium">{{ $t('created_by') | capitalize }}:</td>
            <td>
              {{ loadOrder.created_by_name }}
            </td>
          </tr>
        </table>
      </vs-col>
    </vs-row>

    <vs-popup :title="$t('signature') | capitalize" :active.sync="popupActivo">
      <div v-if="signData.byProxy === 0">
        <img
          :src="`${baseUrl}storage/${signData.file.source}`"
          alt="sign"
          class="w-full"
        />
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Banner from '@/views/components/Banner.vue'
import { BASE_URL } from '@/urls.js'
export default {
  components: {
    Banner,
  },
  data() {
    return {
      baseUrl: BASE_URL,
      popupActivo: false,
    }
  },
  props: {
    loadOrder: {
      type: Object,
      default: () => ({}),
    },
    signData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style>
</style>

